import { NOTIFICATION_RESOURCE } from '../api/resources';
import { addResource, fetchResource } from './remote';

export const fetchNotifications = fetchResource(NOTIFICATION_RESOURCE);
export const markNotificationRead = addResource(NOTIFICATION_RESOURCE, 'mark_read');
export const markAllNotificationsRead = addResource(NOTIFICATION_RESOURCE, 'mark_all_read',
  undefined, 'list');



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/notification.js